import actionTypes from '../constants/action-types';
import constants from '../../../../common/constants';
import ChangePasswordApi from '../../../../api/change-password-api';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { toggleInfoModal, toggleDefaultErrorModal } from '../../../shared/info-modal/actions/info-modal-actions';

export const sendForgotPasswordEmail = email => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      /* eslint-disable */
      const response = await ChangePasswordApi.forgotPassword(email);
      /* eslint-enable */
      dispatch(handleHttpInProgress(false));
      dispatch(toggleForgotPasswordModal(false));
      dispatch(toggleInfoModal(true, constants.info_modal_types.success.value, 'FORGOT_PASSWORD_SUCCESS_MESSAGE', { email }, null));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
      dispatch(toggleDefaultErrorModal());
    }
  };
};

export const toggleForgotPasswordModal = show => {
  return {
    type: actionTypes.TOGGLE_FORGOT_PASSWORD_MODAL,
    data: show,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/forgot-password/actions/forgot-password-actions.js